/*
Simple Text Area
*/

import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Theme } from 'ui_system/theme';
import { Text } from './FormStyles';

const Wrapper = styled.div`
  width: 100%;
  border-style: solid;
  border-color: ${Theme.colors.borderActionableFieldColor};
  border-width: ${(props) => (props.fullborder ? '1px' : '1px')};
  border-top: solid 1px ${Theme.colors.borderActionableFieldColor};
  border-bottom: solid 1px ${Theme.colors.borderActionableFieldColor};
  position: relative;
`;

const TextArea = styled.textarea`
  width: 100%;
  border: none;
  color: ${Theme.colors.primaryTextColor};
  resize: none;
  padding: 17px ${(props) => (props.hidePlaceholderIcon ? '15px' : '45px')};
  height: ${(props) => (props.height ? `${props.height}px` : 'auto')};
  font-size: ${(props) => (props.fontSize ? `${props.fontSize}px` : '16px')};
  transition: height 100ms linear;
  transition-delay: 100ms;
  overflow: hidden;
  &:focus {
    outline: none;
    height: ${(props) =>
      props.focusHeight ? `${props.focusHeight}px` : 'auto'};
    padding: 15px;
    overflow: auto;
  }
  &::placeholder {
    color: ${Theme.colors.secondaryTextColor};
  }
`;

const Warning = styled(Text)`
  text-align: right;
  display: block;
`;

const NoteIcon = styled.i`
  position: absolute;
  top: 21px;
  left: 15px;
  color: ${Theme.colors.iconsNotLinkedColor};
`;

const SimpleTextarea = (props) => {
  const {
    field,
    placeholder,
    height,
    focusHeight,
    fontSize,
    maxLength,
    handleTextChange,
    hidePlaceholderIcon,
    fullborder,
  } = props;
  const [focused, setFocused] = useState(false);
  const [textLimitReached, setTextLimitReached] = useState(false);

  const handleChange = (e) => {
    const val = e.target.value;
    if (val.length === maxLength) {
      setTextLimitReached(true);
      return;
    }
    setTextLimitReached(false);
    handleTextChange(field.name, val);
  };

  const handleTextAreaFocused = () => {
    setFocused(true);
  };

  const handleTextAreaBlurred = () => {
    setTextLimitReached(false);
    setFocused(false);
  };

  return (
    <Fragment>
      <Wrapper fullborder={fullborder}>
        {!focused && !hidePlaceholderIcon && (
          <NoteIcon className="af2-blocked-notes-icon" />
        )}
        <TextArea
          height={height}
          focusHeight={focusHeight}
          fontSize={fontSize}
          limitReached={textLimitReached}
          maxLength={maxLength}
          value={field.value}
          placeholder={placeholder}
          hidePlaceholderIcon={hidePlaceholderIcon}
          onChange={handleChange}
          onFocus={handleTextAreaFocused}
          onBlur={handleTextAreaBlurred}
        />
      </Wrapper>
      {textLimitReached && (
        <Warning small light>
          Text limit reached
        </Warning>
      )}
    </Fragment>
  );
};

SimpleTextarea.defaultProps = {
  height: 60,
  focusHeight: 60,
  fontSize: 16,
  maxLength: 250,
  placeHolder: 'Enter text',
  hidePlaceholderIcon: false,
};

SimpleTextarea.propTypes = {
  field: PropTypes.object.isRequired,
  handleTextChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  height: PropTypes.number,
  focusHeight: PropTypes.number,
  fontSize: PropTypes.number,
  maxLength: PropTypes.number,
  hidePlaceholderIcon: PropTypes.bool,
};

export default SimpleTextarea;
